<template>
    <div class="absolute inset-0 backdrop-blur-sm">
        <!-- Overlay. -->
        <div class="absolute inset-0 bg-gray-700 opacity-75"></div>

        <!-- Content. -->
        <div class="absolute bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
            <on-click-outside :do="close">
                <on-keydown :condition="key => key === 'Escape'" :do="close">
                    <div class="bg-white rounded-lg shadow-xl sm:w-full p-4 sm:p-6" role="dialog" :class="modalSize" aria-modal="true" aria-labelledby="modal-headline" ref="content">
                        
                        <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                            <slot name="icon"></slot>
                            <div class="flex-1">
                                <slot name="header">
                                    <h3
                                        v-if="title"
                                        class="text-lg leading-6 font-medium text-gray-900 mb-2"
                                        id="modal-headline"
                                        v-text="title"
                                        ref="headline"
                                    ></h3>
                                </slot>
                                <slot></slot>
                            </div>
                        </div>

                        <slot name="footer">
                            <div class="mt-5 sm:flex sm:flex-row-reverse">
                                <span class="flex w-full sm:ml-3 sm:w-auto">
                                    <slot name="footer-primary"></slot>
                                </span>
                                <span class="mt-3 flex w-full sm:mt-0 sm:w-auto">
                                    <slot name="footer-secondary">
                                        <ui-button-new v-if="! noCancel" class="w-full" @click="close">{{ closeButton }}</ui-button-new>
                                    </slot>
                                </span>
                                <slot name="footer-extra"></slot>
                            </div>
                        </slot>
                    </div>
                </on-keydown>
            </on-click-outside>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        large: Boolean,
        xlarge: Boolean,
        noCancel: Boolean,
        close: Function,
        closeButton: {
            type: String,
            default: 'Cancel',
        }
    },

    computed: {
        modalSize () {
            if (this.xlarge) return 'sm:max-w-4xl max-w-4xl'
            if (this.large) return 'sm:max-w-2xl max-w-2xl'
            return 'sm:max-w-xl max-w-md'
        },
    },
}
</script>
